import api from "../../api/api";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { userLogout } from "../../features/userSlice";
import { useNavigate } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { useState } from "react";

const useTRSIIOptIn = () => {
  const queryClient = useQueryClient();
  const [isUpdating, setIsUpdating] = useState(false);
  const [updateError, setUpdateError] = useState(null);
  //const [resp, setResp] = useState(null);
  const { authState } = useOktaAuth();

  const accessToken = authState.accessToken.accessToken;

  const updateOptIn = async (updatedServicer) => {
    try {
      const { id } = updatedServicer;
      setIsUpdating(true);
      return await api
        .put(`/servicer/trsii-opt-in/${id}`, updatedServicer, {
          headers: {
            authorization: `Bearer ${accessToken}`,
          },
        })
        .then((response) => {
          if (!response.statusText === "OK") {
            queryClient.invalidateQueries(["queryFetchServicer"]);
            toast.error("Opt-In update Failed");
            return;
          }

          setIsUpdating(false);
          setUpdateError(null);
          return response;
        });
    } catch (error) {
      setIsUpdating(false);
      setUpdateError(error.message);
    }
  };

  return {
    isUpdating,
    updateError,
    updateOptIn,
  };
};

export default useTRSIIOptIn;
